import { render, staticRenderFns } from "./SortMoveHelpCentre.vue?vue&type=template&id=3025b43e&"
import script from "./SortMoveHelpCentre.vue?vue&type=script&lang=js&"
export * from "./SortMoveHelpCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports